import {ListView} from '@github-ui/list-view'
import {ListViewMetadata} from '@github-ui/list-view/ListViewMetadata'
import {Heading} from '@primer/react'

import styles from './RunnerList.module.css'

export interface RunnerListProps {
  heading?: string
  isLoading?: boolean
  listTitle: string
  numberOfRunners: number
  children: React.ReactNode
}

/**
 * See ListView stories for a representation of this component.
 * packages/list-view/src/stories/ActionRunners.stories.tsx
 * https://ui.githubapp.com/storybook/?path=/story/recipes-list-view-dotcom-pages--action-runners
 */
export function RunnerList({
  heading,
  isLoading = false,
  listTitle,
  numberOfRunners,
  children,
  ...props
}: RunnerListProps) {
  const status = isLoading
    ? 'Loading runners'
    : `${numberOfRunners} available runner${numberOfRunners === 1 ? '' : 's'}`

  return (
    <div>
      {heading && (
        <Heading className={styles.heading} as="h2">
          {heading}
        </Heading>
      )}
      <div className={styles.listContainer} {...props}>
        <ListView
          metadata={<ListViewMetadata title={status} />}
          title={listTitle}
          titleHeaderTag={heading ? 'h3' : 'h2'}
        >
          {children}
        </ListView>
      </div>
    </div>
  )
}
